import { useMutation, useQueryClient } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';
import type { StandardTermUpsertRequest } from '../types/terminology';

/**
 * POST /api/eraf/terminology/standard-terms (create)
 * PUT  /api/eraf/terminology/standard-terms/:id (update)
 *
 * On success: invalidates list + summary queries.
 */
export function useUpsertStandardTerm() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id?: number; body: StandardTermUpsertRequest }) =>
      id !== undefined
        ? terminologyApi.updateStandardTerm(id, body)
        : terminologyApi.createStandardTerm(body),
    onSuccess: (_data, variables) => {
      // Invalidate list
      void queryClient.invalidateQueries({
        queryKey: ['terminology', 'standard-terms', 'list'],
      });
      // Invalidate detail if updating
      if (variables.id !== undefined) {
        void queryClient.invalidateQueries({
          queryKey: ['terminology', 'standard-terms', 'detail', variables.id],
        });
      }
      // Invalidate summary (counts may change)
      void queryClient.invalidateQueries({ queryKey: ['terminology', 'summary'] });
    },
  });
}
